import { buildUrl } from '~/router';
import { getStarPrintPdf, getStarPrintUrl } from '~/lib/print/starprint';
import { salePrint } from "~/apps/pos/apis/message";


export async function printPdf(pdfUrl: string): Promise<boolean> {
  try {
    const url = await getStarPrintUrl(pdfUrl, buildUrl('pos.mobile', null, true));
    window.location.assign(url);
    return true;
  } catch (e) {
    alert(`${e}`);
    return false;
  }
}

export async function printSaleById(saleId, useUsualPrinters?) {
  if (!useUsualPrinters) {
    try {
      const url = await getStarPrintPdf(saleId, buildUrl('pos.mobile', null, true));
      window.location.assign(url);
      return true;
    } catch (e) {
      alert(`${e}`);
      return false;
    }
  } else {
    try {
      const req = await salePrint(saleId);
      const blob = await req.blob();
      const url = URL.createObjectURL(blob);
      const win = window.open(url);
      win.print();
    } catch (e) {
      alert(`${e}`);
      return false;
    }
  }
}
